import apollo from '@/assets/icons/onboarding_crm_apollo.png';
import folk from '@/assets/icons/onboarding_crm_folk.png';
import highLevel from '@/assets/icons/onboarding_crm_highlevel.png';
import jobber from '@/assets/icons/onboarding_crm_jobber.png';
import monday from '@/assets/icons/onboarding_crm_monday.png';
import nocrm from '@/assets/icons/onboarding_crm_nocrm.png';
// The dashboard/salesforce.png ships with an opaque background that reads
// poorly on the 16px badge — onboarding_crm_salesforce.png is transparent
// and matches the visual weight of the other onboarding CRM icons.
import salesforce from '@/assets/icons/onboarding_crm_salesforce.png';
import sellsy from '@/assets/icons/onboarding_crm_sellsy.png';
import streak from '@/assets/icons/onboarding_crm_streak.png';
import zohoCrm from '@/assets/icons/onboarding_crm_zoho.png';
import attio from '@/assets/images/dashboard/attio.png';
import googleContacts from '@/assets/images/dashboard/google_contact.png';
import googleSheets from '@/assets/images/dashboard/google_sheets.png';
import hubspot from '@/assets/images/dashboard/hubspot.png';
import make from '@/assets/images/dashboard/make.png';
import notion from '@/assets/images/dashboard/notion.png';
import odoo from '@/assets/images/dashboard/odoo.png';
import pennyLane from '@/assets/images/dashboard/pennylane.png';
import quickbooks from '@/assets/images/dashboard/quickbooks.png';
import shopify from '@/assets/images/dashboard/shopify.png';
import zapier from '@/assets/images/dashboard/zapier.png';
import zohoFlow from '@/assets/images/dashboard/zoho.png';

const externalDataIcons: Record<string, string> = {
  SHOPIFY: shopify,
  ATTIO: attio,
  HUBSPOT: hubspot,
  GOOGLE_SHEETS: googleSheets,
  GOOGLE_CONTACTS: googleContacts,
  QUICKBOOKS: quickbooks,
  PENNYLANE: pennyLane,
  SALESFORCE: salesforce,
  NOTION: notion,
  MAKE: make,
  ZAPIER: zapier,
  ZOHO_FLOW: zohoFlow,
  ZOHO_CRM: zohoCrm,
  ODOO: odoo,
  FOLK: folk,
  HIGHLEVEL: highLevel,
  STREAK: streak,
  SELLSY: sellsy,
  APOLLO: apollo,
  JOBBER: jobber,
  MONDAY: monday,
  NOCRM: nocrm,
};

export const renderExternalDataIcons = (externalData: {
  [key: string]: {
    [key: string]: unknown;
  };
}) => {
  if (!externalData) {
    return null;
  }

  return Object.keys(externalData).map((key) => {
    const icon = externalDataIcons[key];
    return icon ? <img key={key} src={icon} alt={key} width={20} /> : null;
  });
};
